var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArticleLove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4647 10.6229C9.86494 9.9412 8.86472 9.75781 8.11321 10.3821C7.36169 11.0064 7.25589 12.0501 7.84606 12.7885C8.43622 13.5268 10.4647 15.25 10.4647 15.25C10.4647 15.25 12.4933 13.5268 13.0834 12.7885C13.6736 12.0501 13.5807 10.9998 12.8163 10.3821C12.0518 9.76438 11.0645 9.9412 10.4647 10.6229Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7168 7V4.6C12.7168 3.33988 12.7168 2.70982 12.4716 2.22852C12.2558 1.80516 11.9116 1.46095 11.4883 1.24524C11.007 1 10.3769 1 9.1168 1H4.3168C3.05668 1 2.42662 1 1.94532 1.24524C1.52195 1.46095 1.17775 1.80516 0.962032 2.22852C0.716797 2.70982 0.716797 3.33988 0.716797 4.6V12.4C0.716797 13.6601 0.716797 14.2902 0.962032 14.7715C1.17775 15.1948 1.52195 15.539 1.94532 15.7548C2.42662 16 3.05668 16 4.3168 16H6.7168M7.0918 7.75H3.7168M4.4668 10.75H3.7168M9.7168 4.75H3.7168M10.4647 10.6229C9.86494 9.9412 8.86472 9.75781 8.11321 10.3821C7.36169 11.0064 7.25589 12.0501 7.84606 12.7885C8.43623 13.5268 10.4647 15.25 10.4647 15.25C10.4647 15.25 12.4933 13.5268 13.0834 12.7885C13.6736 12.0501 13.5807 10.9998 12.8163 10.3821C12.0518 9.76438 11.0645 9.9412 10.4647 10.6229Z",
    stroke: "#0D3355",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleLove);
export default __webpack_public_path__ + "static/media/article-love.3858f898.svg";
export { ForwardRef as ReactComponent };